:host {
  display: block;
  height: 100%;
  min-height: 600px;
}

.ai-chat-container {
  width: 100%;
  height: 100%;
  background: var(--ux-color-background-default);
  border-radius: var(--ux-border-radius-large);
  box-shadow: var(--ux-shadow-small);
  overflow: hidden;
  padding: 20px;
}

.error, .empty {
  padding: 2rem;
  text-align: center;
  color: var(--ux-color-text);
  background: var(--ux-color-background-subtle);
  border-radius: var(--ux-border-radius);
  margin: 1rem;
}

.error {
  color: var(--ux-color-error);
  background: var(--ux-color-error-subtle);
}

/* Style the UX Chat component */
::slotted(ux-chat) {
  height: 100%;
  min-height: 500px;
  display: flex;
  flex-direction: column;
}
